const T = {
  CreditDebitCard: "CREDIT_DEBIT_CARD",
  OnAccountBalance: "ON_ACCOUNT_BALANCE",
  AmwayPoints: "AMWAY_POINTS",
  CreditVoucher: "CREDIT_VOUCHER",
  StaffEntitlement: "STAFF_ENTITLEMENT",
  QrCode: "QR_CODE",
  InstallmentPayment: "INSTALLMENT_PAYMENT",
  OnlineBanking: "ONLINE_BANKING",
  PayLaterQr: "PAY_LATER_QR",
  Cash: "CASH",
  BankPayout: "BANK_PAYOUT",
  ThMpos: "TH_MPOS",
  ThTms: "TH_TMS",
  ThCnb: "TH_CNB",
  ThPayLaterCnb: "TH_PAY_LATER_CNB",
  ZeroChargePayment: "ZERO_CHARGE_PAYMENT",
  DirectDebitBanking: "DIRECT_DEBIT_BANKING",
  PayLaterCash: "PAY_LATER_CASH",
  OfflineBanking: "OFFLINE_BANKING",
  NgcRoundingPayment: "NGC_ROUNDING_PAYMENT"
};
function N(n) {
  return t(n);
}
function t(n, e) {
  return n;
}
function a(n) {
  return n;
}
export {
  T as PaymentMethodId,
  N as PaymentMethodIdFromJSON,
  t as PaymentMethodIdFromJSONTyped,
  a as PaymentMethodIdToJSON
};
//# sourceMappingURL=PaymentMethodId.js.map
